import DashboardIcon from "@mui/icons-material/Dashboard";
import BeachAccessIcon from "@mui/icons-material/BeachAccess";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import AssessmentIcon from "@mui/icons-material/Assessment";
import ListAltIcon from "@mui/icons-material/ListAlt";
import PowerSettingsNewIcon from "@mui/icons-material/PowerSettingsNew";
import { MenuItems } from "../../interface/menuItemsInterface";
import HomeWorkIcon from '@mui/icons-material/HomeWork';

const userSideBarItems: MenuItems[] = [
    { i: 1, name: "Dashboard", icon: <DashboardIcon />, link: "/" },
    {
        i: 3,
        name: "Holidays",
        icon: <BeachAccessIcon />,
        link: "/holidays",
    },

    {
        i: 5,
        name: "Documents",
        icon: <InsertDriveFileIcon />,
        link: "/documents",
    },
    {
        i: 6,
        name: "Skills review",
        icon: <AssessmentIcon />,
        link: "/skills",
        subitems: [
            { i: 8, name: "List", icon: <ListAltIcon />, link: "/skills/list" },
        ],
    },
    {
        i: 11,
        name: "Home Offie",
        icon: <HomeWorkIcon />,
        link: "/home_office",
    },
    {
        i: 15,
        name: "Logout",
        icon: <PowerSettingsNewIcon />,
        link: "/#",
    },
];

export default userSideBarItems;
